export function ReturnIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      {...props}
    >
      <path
        d="M7 5.99996L7.94667 6.94663L5.55333 9.33329H11.6667V2.66663H13V10.6666H5.55333L7.94667 13.0533L7 14L3 9.99996L7 5.99996Z"
        fill="currentColor"
      />
    </svg>
  )
}
